export function LogoutButton({ onClick }: { onClick: () => void }) {
  return (
    <button className="admin-icon-action admin-icon-action_row" aria-label="Выйти" onClick={onClick} type="button">
      <svg className="admin-logout-icon" aria-hidden="true" viewBox="0 0 24 24">
        <path d="M9 5H6.5A1.5 1.5 0 0 0 5 6.5v11A1.5 1.5 0 0 0 6.5 19H9" />
        <path d="M14 8l4 4-4 4" />
        <path d="M18 12H9" />
      </svg>
    </button>
  );
}
